import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import config from "../config";
import "../styles/billing.css";
import Home from "../assets/SVG/buttons/Home-button-big.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  createStripeCustomer,
  createStripeSubscription,
  getAllStripeTransactions,
  getCustomerByUid,
  getSubscriptionByUid,
} from "../api";
import Profile from "../assets/SVG/icons/Avatar.svg";
import Logout from "../assets/SVG/buttons/logout.svg";
import * as action from "../actions";
import axios from "axios";
import {useHistory} from "react-router-dom";
import CheckoutForm from "../components/CheckoutForm";

// Make sure to call `loadStripe` outside a components render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(config.stripe.pub_key);

const priceId100 = "price_1NlDvVJkcw3plchcNVHK1M2g";
const priceId200 = "price_1No76oJkcw3plchcDGzIYja0";

const Account = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const [subscription, setSubscription] = useState();
  const [clientSecret, setClientSecret] = useState();
  const [planPrice, setPlanPrice] = useState();
  const [stripeCustomer, setStripeCustomer] = useState();
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleLogout = () => {
    axios
      .get(config.backend_url + "/logout")
      .then(function (response) {
        history.push("/login");
        dispatch(action.logoutUser());
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const createSubscription = async () => {
    const stripeCustomerId = stripeCustomer?.customerId;
    const priceId = planPrice;
    const _uid = user.uid;

    if (!stripeCustomerId || !priceId) {
      return alert("stripeCustomerId or priceId missing");
    }

    const createStripeSubscriptionResp = await createStripeSubscription({
      stripeCustomerId,
      priceId,
      uid: _uid,
      // collectionMethod: "send_invoice", // charge_automatically (Default) | send_invoice 
      // TODO FIX
    });
    setClientSecret(createStripeSubscriptionResp?.clientSecret);
    setSubscription(createStripeSubscriptionResp?.subscription);
    dispatch(action.updateSubscription(createStripeSubscriptionResp?.subscription));
  };

  const subscribeHandler = async () => {
    await createSubscription();
  };

  useEffect(() => {
    // Check if Stripe customer exist | if not create one
    getCustomerByUid(user.uid).then(async (res) => {
      try {
        // Get the stripe customer object
      if (res.customer) {
        setStripeCustomer(res.customer);
      } else {
        // Create customer in stripe and save it to database.
        const email = user.email;
        const fullName = user.firstName + " " + user.lastName;
        const country = user?.address?.country;
        const state = user?.address?.stateProvince;
        const stripeCustomerResp = await createStripeCustomer({ email, fullName, country, state, uid: user.uid });
        setStripeCustomer(stripeCustomerResp.customer);
      }
      // Retrieve and set the subscription | if not provide option to create subscription for list of products.
      const subscriptionResp = await getSubscriptionByUid(user.uid);

      if (!subscriptionResp.subscription) {
        console.log("No subscription:: creating new one...");
        // Create new subscription
        return;
      }
      
      setSubscription(subscriptionResp.subscription);

      // Get all transactions
      const transactions = getAllStripeTransactions()
      
      // Get latest invoice status from subscription

      // Display UI
      setIsLoading(false)
      } catch (error) {
        console.log("error", error)
      }
      
    });
  }, []);

  const options = {
    // passing the client secret obtained from the server
    clientSecret: clientSecret,
  };

  const fullRedirectToHome = () => {
    history.push("/home");
  }

  return (
    <div className="container" data-testid="main-container">
      <div className="main navigation" data-testid="navigation">
        <div className="header mt-3">
          <img src={Home} alt="home" onClick={fullRedirectToHome}></img>
          <img
            src={user?.picture ? user.picture : Profile}
            alt="profile"
            className="profile mt-4"
            onClick={() => history.push("/navigation")}
          ></img>
          <img src={Logout} alt="logout" data-testid="logout-btn" onClick={handleLogout}></img>
        </div>
        <p className="text-center mt-3 heading">Account</p>
        {isLoading && <div id="cover-spin"></div>}
        {(paymentSuccess) ?
          <div className="wrapper" data-testid="wrapper">
            <div className="checkmark-container">
              <i className="checkmark">✓</i>
            </div>
            <div data-testid="success-title" className="success-title">Payment Successful</div>
            <div>Your payment was successful.</div>
            <div>You can continue using iSelfie.</div>
            <button className="success-home" onClick={fullRedirectToHome}>
              Go to Home
            </button>
          </div>
          :
          <div className="wrapper" data-testid="wrapper">
            {subscription?.stripe?.latest_invoice?.paid ? (
              <div data-testid="account-active-text">Your account is active.</div>
            ) : (
              <div className="billing-container">
                {subscription ? (
                  <div data-testid="complete-payment-text">Complete the payment</div>
                ) : (
                  <>
                    <div className="select-subscription">
                      <div className="plan-container" data-testid="plan-container-id-100-btn"
                           onClick={() => setPlanPrice(priceId100)}>
                        <input type="radio" name="plan" data-testid="plan-container-id-100-checkbox"
                               checked={planPrice === priceId100}></input>
                        <div className="plan-1">
                          <div className="plan-1-title">Covid Plan 1</div>
                          <div className="plan-1-description">Description for Covid Plan 1</div>
                        </div>
                      </div>
                      <div className="plan-container" data-testid="plan-container-id-200-btn"
                           onClick={() => setPlanPrice(priceId200)}>
                        <input type="radio" name="plan" data-testid="plan-container-id-200-checkbox"
                               checked={planPrice === priceId200}></input>
                        <div className="plan-2">
                          <div className="plan-2-title">Covid Plan 2</div>
                          <div className="plan-2-description">Description for Covid Plan 2</div>
                        </div>
                      </div>
                    </div>
                    <div className="subscribe-cta">
                      <button className="subscribe-button" data-testid="subscribe-btn" disabled={!planPrice} onClick={subscribeHandler}>
                        Subscribe
                      </button>
                    </div>
                  </>
                )}
                {clientSecret && (
                  <div className="stripe-container" data-testid="stripe-container">
                    <Elements stripe={stripePromise} options={options}>
                      <CheckoutForm setPaymentSuccess={setPaymentSuccess}/>
                    </Elements>
                  </div>
                )}
              </div>
            )}
          </div>
        }
      </div>
    </div>
  );
};

export default Account;
